export const chains = {
  [1]: {
    name: "mainnet",
    prefix: "eth",
  },
  [10]: {
    name: "optimism",
    prefix: "oeth",
  },
  [100]: {
    name: "gnosis",
    prefix: "gno",
  },
  [1101]: {
    name: "zkevm",
    prefix: "zkevm",
  },
  [11155111]: {
    name: "sepolia",
    prefix: "sep",
  },
  [137]: {
    name: "polygon",
    prefix: "matic",
  },
  [146]: {
    name: "sonic",
    prefix: "sonic",
  },
  [42161]: {
    name: "arbitrumOne",
    prefix: "arb1",
  },
  [42220]: {
    name: "celo",
    prefix: "celo",
  },
  [43114]: {
    name: "avalanche",
    prefix: "avax",
  },
  [56]: {
    name: "bsc",
    prefix: "bnb",
  },
  [130]: {
    name: "unichain",
    prefix: "unichain",
  },
  [480]: {
    name: "worldchain",
    prefix: "worldchain",
  },
  [5000]: {
    name: "mantle",
    prefix: "mantle",
  },
  [57073]: {
    name: "ink",
    prefix: "ink",
  },
  [60808]: {
    name: "bob",
    prefix: "bob",
  },
  [747474]: {
    name: "katana",
    prefix: "katana",
  },
  [80094]: {
    name: "berachain",
    prefix: "berachain",
  },
  [8453]: {
    name: "base",
    prefix: "base",
  },
  [84532]: {
    name: "baseSepolia",
    prefix: "basesep",
  },
  [999]: {
    name: "hyperevm",
    prefix: "hyperevm",
  },
  [14]: {
    name: "flare",
    prefix: "flr",
  },
  [534352]: {
    name: "scroll",
    prefix: "scr",
  },
  [9745]: {
    name: "plasma",
    prefix: "plasma",
  },
  [4326]: {
    name: "megaeth",
    prefix: "megaeth",
  },
} as const
